import asyncRoute from './asyncRoute';

export const GoHomeContainer  = asyncRoute(() => import('@/containers/main/GoHomeContainer'));
export const WorkTimeCalendarContainer  = asyncRoute(() => import('@/containers/main/WorkTimeCalendarContainer'));
export const Changelog = asyncRoute(() => import('@/components/history/Changelog'));
export const ToDo = asyncRoute(() => import('@/components/history/ToDo'));




// WEBPACK FOOTER //
// ./src/router/pages.async.js